import React from "react";
import { TableHeader, TableHeaderProps } from './tableHeader';
import { TableRow, TableRowProps } from './tableRow';

export interface TableProps {
    tableHeader: TableHeaderProps;
    tableRows: Array<TableRowProps>;
    customHeader?: JSX.Element;
    tableClass?: string;
    areAllRowsExpanded?: boolean;
}

export const Table = ({
    tableHeader,
    tableRows,
    customHeader,
    tableClass,
    areAllRowsExpanded
}: TableProps) => {

    const checkForExtraContent = (element) => element.extraContent !== undefined;
    let extraContent = tableRows.some(checkForExtraContent);

    return (
        <table className={`wbm-generic-table ${tableClass}`}>
            {customHeader}
            <TableHeader tableCells={tableHeader.tableCells} dropdownInUse={extraContent} />
            <tbody>
                {tableRows.map((tableRow, index) => {
                    return <TableRow
                        tableCells={tableRow.tableCells}
                        extraContent={tableRow.extraContent}
                        dropdownInUse={extraContent}
                        key={`product-${index}`}
                        rowId={tableRow.rowId}
                        buttonPressed={tableRow.buttonPressed}
                        rowNumber={index} rowClass={tableRow.rowClass}
                        areAllRowsExpanded={areAllRowsExpanded} />
                })}
            </tbody>
        </table>
    );
};